import { createAction } from "redux-actions";

const namespace = "app/bottomNavigation";

const SET_VALUE_ACTION = `${namespace}/SET_VALUE`;
const SET_DESKTOP_NOTIFICATIONS_OPEN = `${namespace}/SET_DESKTOP_NOTIFICATIONS_OPEN`;

export const constants = {
  SET_VALUE_ACTION,
  SET_DESKTOP_NOTIFICATIONS_OPEN
};

const setValueAction = createAction(SET_VALUE_ACTION, value => ({ value }));
const setDesktopNotificationsOpenAction = createAction(
  SET_DESKTOP_NOTIFICATIONS_OPEN,
  open => ({ open })
);

export const actions = {
  setValueAction,
  setDesktopNotificationsOpenAction
};

const initialState = {
  currentValue: null,
  desktopNotificationsOpen: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_VALUE_ACTION:
      let previousValue = state.currentValue;
      let newValue = action.payload.value;

      return {
        ...state,
        currentValue: previousValue !== newValue ? newValue : null
      };

    case SET_DESKTOP_NOTIFICATIONS_OPEN:
      return {
        ...state,
        desktopNotificationsOpen: Boolean(action.payload.open)
      };

    default:
      return state;
  }
}
